import { useQuery } from "@tanstack/react-query";
import { mvpApiSearchProducts } from "@labeling-tools/api/atlas";

export const useAtlasSearch = (
  searchTerm: string | null | undefined,
  page_size: number = 12,
) => {
  return useQuery({
    queryKey: ["atlasSearch", searchTerm],
    queryFn: async () => {
      const response = await mvpApiSearchProducts({
        query: {
          q: searchTerm || "",
          page: 1,
          page_size: page_size,
        },
      });

      if (response.error) {
        throw new Error(`Failed to search products: ${response.error}`);
      }

      return response.data;
    },
    enabled: typeof searchTerm === "string",
  });
};
